import { render, staticRenderFns } from "./ResTwoListSelect.vue?vue&type=template&id=207bc730&scoped=true"
import script from "./ResTwoListSelect.vue?vue&type=script&lang=js"
export * from "./ResTwoListSelect.vue?vue&type=script&lang=js"
import style0 from "./ResTwoListSelect.vue?vue&type=style&index=0&id=207bc730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bc730",
  null
  
)

export default component.exports